import { PoStorageService } from '@po-ui/ng-storage';

export interface IFiltroRelatorioTransferenciasExpedicao {
  lastSetDefault: Date;

  DB8DATA_DE: Date | undefined;
  DB8DATA_ATE: Date | undefined;
  CB8LOTECTL: string;
  CB8PRODUTO: string;
  CB8LOCAL: string;
}

export class FiltroRelatorioTransferenciasExpedicao {

  dados: IFiltroRelatorioTransferenciasExpedicao;
  storageName: string;

  constructor(private poStorageService: PoStorageService) {

    this.dados = this.setDefault();
    this.storageName = 'interface-filtro-relatorio-transferencias-expedicao';

    this.poStorageService.get(this.storageName).then((filtro: IFiltroRelatorioTransferenciasExpedicao) => {
      if (filtro) {

        const {
          lastSetDefault,
          DB8DATA_DE,
          DB8DATA_ATE
        } = filtro;

        if (!lastSetDefault && (new Date().getDay() - new Date(lastSetDefault).getDay())) {
          this.dados = this.setDefault();
        } else {
          this.dados = {
            ...filtro,
            lastSetDefault: new Date(lastSetDefault),
            DB8DATA_DE: DB8DATA_DE ? new Date(DB8DATA_DE) : undefined,
            DB8DATA_ATE: DB8DATA_ATE ? new Date(DB8DATA_ATE) : undefined,
          };
        }
      }
    });
  }

  public setDefault = (): IFiltroRelatorioTransferenciasExpedicao => {
    return {
      lastSetDefault: new Date(),
      DB8DATA_DE: this.getData(-7),
      DB8DATA_ATE: new Date(),
      CB8LOTECTL: '',
      CB8PRODUTO: '',
      CB8LOCAL: '',
    };
  }

  public setStorage = (): void => {
    this.poStorageService.set(this.storageName, this.dados);
  }

  private getData = (dias: number): Date => {
    const dataDe = new Date();
    dataDe.setDate(dataDe.getDate() + dias);
    return dataDe;
  }

}
